import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { RepeatPurchaseMobileModalProps } from './RepeatPurchaseMobileModal';

export const renderRepeatPurchaseMobileModal = ({ onClose, ...data }: RepeatPurchaseMobileModalProps) =>
    openPopupHelper({ popupName: popupNames.REPEAT_PURCHASE_MOBILE, data, onClose });

export const closeRepeatPurchaseMobileModal = () => closePopupHelper(popupNames.REPEAT_PURCHASE_MOBILE);
